import React from "react";

interface Props {
  color?: string;
}

const CaretDoubleDown = ({ color = "#101828" }: Props) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1668 8.46667L7.50016 13.1333L2.8335 8.46667"
      stroke={color}
      strokeWidth="0.933333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1668 3.8L7.50016 8.46667L2.8335 3.8"
      stroke={color}
      strokeWidth="0.933333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CaretDoubleDown;
